import { render, staticRenderFns } from "./secondwanjie.vue?vue&type=template&id=22469637&scoped=true"
import script from "./secondwanjie.vue?vue&type=script&lang=js"
export * from "./secondwanjie.vue?vue&type=script&lang=js"
import style0 from "./secondwanjie.vue?vue&type=style&index=0&id=22469637&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22469637",
  null
  
)

export default component.exports